import type { JSX } from 'react';
import useScrollPosition from '~/hooks/use-scroll-position';

type Props = {
	scrollingContainer: Element | null;
	children: (scrollYPosition: number) => JSX.Element;
};

const ScrollAware = ({ children, scrollingContainer }: Props) => {
	const { scrollYPosition } = useScrollPosition(scrollingContainer);

	return children(scrollYPosition);
};

export default ScrollAware;
